// Detect when legs in the same dispatch group have inconsistent driver
// assignments — either a mix of assigned/unassigned, or two different drivers
// across legs. Used to surface a warning indicator on the dispatch table so
// dispatchers see at a glance that user error has split a single dispatch
// across drivers.

interface LegDriverInfo {
  legnum: number;
  driver?: string;
}

// Returns a user-facing tooltip describing the conflict, or null when all
// legs share the same assignment (or all are unassigned). Single-leg groups
// are never a conflict.
export function describeDispatchGroupDriverConflict(
  legs: LegDriverInfo[] | undefined
): string | null {
  if (!legs || legs.length < 2) return null;

  const trimmed = legs.map((l) => ({
    legnum: l.legnum,
    driver: (l.driver ?? '').trim(),
  }));

  const distinct = new Set(trimmed.map((l) => l.driver));
  if (distinct.size <= 1) return null;

  const parts = trimmed
    .slice()
    .sort((a, b) => a.legnum - b.legnum)
    .map((l) => `Leg ${l.legnum}: ${l.driver || 'unassigned'}`);
  return `Driver mismatch across dispatch group — ${parts.join(', ')}`;
}
